angular.module('core').filter('totalTime', [ 'numberFilter', 'moment',
  function($numberFilter, $moment) {

    return function(milliseconds) {
      if(_.isUndefined(milliseconds) || !_.isNumber(milliseconds)) {
        return '0';
      }
      else {
        var duration = $moment.duration(milliseconds);

        if (duration.asHours() >= 1) {
          return $numberFilter(Math.round(duration.asHours() * 10) / 10) + ' hr';
        }

        var minutes = Math.floor(duration.asMinutes());
        return $numberFilter(minutes) + (minutes === 0 ? '' : ' min');
      }
    };

  }
]);
